import _ from 'lodash';
import { RecruitmentActivityType } from '../../../../../../shared/types/recruitmentTypes';
import { RecruitmentEntityType } from '../../../../../../shared/types/recruitmentTypes';

const PATHS_FOR_ACTIVITY: any = Object.values(RecruitmentActivityType).reduce(
  (accum: any, item: RecruitmentActivityType) => {
    accum[item] = `recruitment.${item}`;
    return accum;
  },
  {}
);

function generateSearchPath(profile: any, params: string[]) {
  if (profile.entity_type === RecruitmentEntityType.Guild) {
    return `/search?type=character&${params.join('&')}`;
  } else if (profile.entity_type === RecruitmentEntityType.Character) {
    return `/search?type=guild&${params.join('&')}`;
  }

  return null;
}

export function buildSearchUrlFromProfile(profile: any) {
  const prefix = PATHS_FOR_ACTIVITY[profile.activity_type];
  if (!prefix) {
    console.error(`Failed to find path for activity type ${profile.activity_type}`);
    return null;
  }

  // const params: string[] = [
  //   ...getCommonSearchparams(profile, prefix),
  //   ...getSearchParamsForEntity(profile, prefix),
  //   ...getSearchParamsForActivity(profile, prefix)
  // ];

  const params: string[] = [`${prefix}.$profile[0][eq]=${profile.id}`];

  return generateSearchPath(profile, params);
}
